"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineageCountsCacher = void 0;
var React = require("react");
/**
 * This component caches the values of two "counts" objects.
 * It also passes through a single "loading" boolean (without caching it).
 *
 * For either (or both) "counts" objects, a new value can be provided, or it can be left undefined.
 * Providing a new value will populate the cache and pass the new value to the children.
 * Leaving a value undefined will cause the cached value to be passed to the children.
 *
 * The cached value for each object is initially null.
 */
var LineageCountsCacher = /** @class */ (function (_super) {
    __extends(LineageCountsCacher, _super);
    function LineageCountsCacher(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            unfilteredCounts: props.newUnfilteredCounts || null,
            filteredCounts: props.newFilteredCounts || null,
        };
        return _this;
    }
    LineageCountsCacher.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            unfilteredCounts: nextProps.newUnfilteredCounts !== undefined ? nextProps.newUnfilteredCounts : prevState.unfilteredCounts,
            filteredCounts: nextProps.newFilteredCounts !== undefined ? nextProps.newFilteredCounts : prevState.filteredCounts,
        };
    };
    LineageCountsCacher.prototype.render = function () {
        return this.props.children({
            countsLoading: this.props.countsLoading,
            unfilteredCounts: this.state.unfilteredCounts,
            filteredCounts: this.state.filteredCounts,
        });
    };
    return LineageCountsCacher;
}(React.Component));
exports.LineageCountsCacher = LineageCountsCacher;
//# sourceMappingURL=LineageCountsCacher.js.map